import {
    ArrowLeft,
    CircleDot,
    FileSpreadsheet,
    RefreshCw,
    GitBranch,
} from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import EditPipelineSheetDrawer from "../../components/PipelineImport/EditPipelineSheetDrawer";

export default function WorkflowHeader({ workflow }) {
    const {
        loading,
        refreshWorkflow,
    } = workflow;
    const [sheetEditorOpen, setSheetEditorOpen] = useState(false);
    const pipeline = workflow.workflow?.pipeline;
    const stages = workflow.workflow?.stages || [];
    const navigate = useNavigate();
    const nodeCount = stages.reduce((total, stage) => total + (stage.nodes?.length || 0), 0);

    const handleUpdated = async () => {
        setSheetEditorOpen(false);
        await refreshWorkflow();
        toast.success("Pipeline updated from spreadsheet");
    };

    return (
        <>
        <header className="flex min-h-[76px] items-center justify-between gap-6 border-b border-[#dce8f3] bg-white px-5 py-3 shadow-[0_3px_14px_rgba(31,78,121,0.04)] lg:px-6">

            {/* Left */}
            <div className="flex min-w-0 items-center gap-3">

                <button type="button" onClick={() => navigate("/admin/pipelines")} className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-[#dce8f3] text-[#607b9f] transition hover:border-[#b9dcef] hover:bg-[#f2f9fd] hover:text-[#147db5]" title="Back to pipelines" aria-label="Back to pipelines">
                    <ArrowLeft className="h-[18px] w-[18px]" />
                </button>

                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-[#e7f6fd] to-[#dcefff] text-[#147db5]">

                    <GitBranch
                        size={22}
                        className="text-[#147db5]"
                    />

                </div>

                <div className="min-w-0">

                    <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#1689c1]">Pipeline builder</p>

                    <div className="mt-0.5 flex min-w-0 items-center gap-2">
                        <h1 className="truncate text-lg font-bold tracking-[-0.02em] text-[#102b5c]">{pipeline?.name || "Loading pipeline..."}</h1>
                        {pipeline?.is_default && <span className="shrink-0 rounded-full bg-emerald-50 px-2 py-0.5 text-[10px] font-bold text-emerald-700">Default</span>}
                    </div>

                    <p className="mt-0.5 flex items-center gap-2 text-xs text-[#7386a5]">
                        <span>{stages.length} stages</span><CircleDot className="h-2.5 w-2.5" /><span>{nodeCount} actions</span>
                    </p>

                </div>

            </div>

            {/* Right */}
            <div className="flex shrink-0 items-center gap-2">

                <button
                    onClick={refreshWorkflow}
                    disabled={loading}
                    className="flex h-10 items-center gap-2 rounded-xl border border-[#d5e4f2] bg-white px-3.5 text-sm font-bold text-[#536b91] transition hover:bg-[#f5f9fd] disabled:cursor-not-allowed disabled:opacity-50"
                >

                    <RefreshCw
                        size={16}
                        className={loading ? "animate-spin" : ""}
                    />

                    Refresh

                </button>

                <button
                    type="button"
                    onClick={() => setSheetEditorOpen(true)}
                    disabled={!pipeline || loading}
                    className="flex h-10 items-center gap-2 rounded-xl bg-gradient-to-r from-[#0f5b8a] to-[#2493d3] px-4 text-sm font-bold text-white shadow-lg shadow-[#147db5]/15 transition hover:-translate-y-0.5 disabled:cursor-not-allowed disabled:opacity-50"
                >
                    <FileSpreadsheet size={16} />
                    Edit with sheet
                </button>

            </div>

        </header>
        <EditPipelineSheetDrawer
            pipeline={pipeline}
            isOpen={sheetEditorOpen}
            onClose={() => setSheetEditorOpen(false)}
            onUpdated={handleUpdated}
        />
        </>
    );
}
